var React = require('react');

function ArrowRight16 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M8.22 2.97a.75.75 0 011.06 0l4.25 4.25a.75.75 0 010 1.06l-4.25 4.25a.75.75 0 01-1.06-1.06l2.97-2.97H3.75a.75.75 0 010-1.5h7.44L8.22 4.03a.75.75 0 010-1.06z"}));
}

ArrowRight16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ArrowRight16;

ArrowRight16.default = ArrowRight16;
